module.exports = __webpack_public_path__ + "static/media/CBSE2012.d65873ba.jpg";